import { isAdminRole, normalizeRoleName } from "./authSession";

export const appRoutes = [
  {
    href: "/admin/dashboard",
    adminOnly: true,
    matches: (path) => path === "/admin/dashboard" || path.startsWith("/admin/dashboard/"),
  },
  {
    href: "/admin/manage-user",
    route: "user management",
    matches: (path) => path.startsWith("/admin/manage-user"),
  },
  {
    href: "/admin/course-management",
    route: "course management",
    matches: (path) => path.startsWith("/admin/course-management"),
  },
  {
    href: "/admin/requests",
    route: "manage requests",
    matches: (path) =>
      path.startsWith("/admin/requests") || path.startsWith("/request/"),
  },
  {
    href: "/admin/purchases",
    route: "manage payments",
    matches: (path) => path.startsWith("/admin/purchases"),
  },
  {
    href: "/admin/activity-log",
    route: "activity log",
    matches: (path) => path.startsWith("/admin/activity-log"),
  },
  {
    href: "/admin/student-progress",
    route: "student progress",
    matches: (path) => path.startsWith("/admin/student-progress"),
  },
  {
    href: "/admin/deletion-history",
    route: "deletion history",
    matches: (path) => path.startsWith("/admin/deletion-history"),
  },
  {
    href: "/admin/certificates",
    adminOnly: true,
    matches: (path) => path.startsWith("/admin/certificates"),
  },
];

export const findRoleDefinition = (roles, roleName) => {
  const key = normalizeRoleName(roleName).toLowerCase();

  if (!key || !Array.isArray(roles)) {
    return null;
  }

  return (
    roles.find((role) => {
      const name = normalizeRoleName(
        role?.name || role?.roleName || role?.role,
      ).toLowerCase();
      const id = String(role?._id || role?.id || "")
        .trim()
        .toLowerCase();

      return name === key || (id && id === key);
    }) || null
  );
};

export const getRoleRoutePermissions = (role) => {
  const permissions = role?.routePermission || role?.routePermissions;
  return Array.isArray(permissions) ? permissions : [];
};

const hasRoutePermission = (routePermissions, routeName) => {
  if (!Array.isArray(routePermissions) || !routeName) {
    return false;
  }

  const expected = routeName.toLowerCase();

  return routePermissions.some(
    (item) => String(item?.route || "").trim().toLowerCase() === expected,
  );
};

export const canAccessPath = (profile, path) => {
  if (!profile) {
    return false;
  }

  if (path === "/admin/no-access") {
    return true;
  }

  if (profile.fullAccess || isAdminRole(profile.role)) {
    return true;
  }

  const rule = appRoutes.find((item) => item.matches(path));

  if (!rule || rule.adminOnly || !Array.isArray(profile.routePermissions)) {
    return false;
  }

  return hasRoutePermission(profile.routePermissions, rule.route);
};

export const getLandingPath = (profile) => {
  if (!profile) {
    return "/";
  }

  if (profile.fullAccess || isAdminRole(profile.role)) {
    return "/admin/dashboard";
  }

  const match = appRoutes.find(
    (item) =>
      !item.adminOnly &&
      hasRoutePermission(profile.routePermissions, item.route),
  );

  return match?.href || "/admin/no-access";
};
